var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", { staticClass: "my-app" }, [
      _vm._v("  "),
      _c("a", { attrs: { href: "https://github.com/gridonic/generator" } }, [
        _vm._v("@gridonic/generator")
      ]),
      _vm._v(" was here.\n")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }